module.exports = __webpack_public_path__ + "img/index4.03a81995.png";